import * as React from 'react';
import { Column, DataTableData } from '../DataTable';

export interface CellProps<T extends DataTableData> {
    /**
     * The column this cell is for
     */
    column: Column;
    /**
     * The item this cell is for
     */
    item: T;
    /**
     * The CSS class to use on this cell
     */
    className: string;
    /**
     * Optional input change handler if this is an input cell
     */
    onInputChange?: (value: string) => void;
}

/**
 * This component represents an individual cell
 */
export class Cell<T extends DataTableData> extends React.Component<
    CellProps<T>
> {
    render() {
        return (
            <td
                key={this.props.item.key}
                className={'simple-data-table-cell ' + this.props.className}
            >
                {this.getCellContents()}
            </td>
        );
    }

    /**
     * Builds the cell contents
     */
    private getCellContents() {
        const column = this.props.column;
        const item = this.props.item;
        const cellContents = column.displayOverride
            ? column.displayOverride(item[column.key])
            : item[column.key];

        switch (column.type) {
            case 'SIMPLE':
                return cellContents;
            case 'INPUT':
                return (
                    <input
                        type="text"
                        id={column.key + '_' + item.key}
                        value={item[column.key]}
                        onChange={event => {
                            if (this.props.onInputChange) {
                                this.props.onInputChange(event.target.value);
                            }
                        }}
                    />
                );
            case 'LINK':
                return (
                    <a
                        href="#"
                        onClick={() => {
                            if (column.linkCallback) {
                                column.linkCallback(item.key);
                            }
                        }}
                    >
                        {cellContents}
                    </a>
                );
        }
    }
}
